import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('qr_token');
    if (!token) {
      setLoading(false);
      return;
    }

    api
      .get('/auth/user')
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem('qr_token');
        localStorage.removeItem('qr_user');
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    const { user: loggedInUser, token } = res.data;
    localStorage.setItem('qr_token', token);
    localStorage.setItem('qr_user', JSON.stringify(loggedInUser));
    setUser(loggedInUser);
    return { success: true, user: loggedInUser };
  };

  const register = async (userData) => {
    const res = await api.post('/auth/register', {
      name: userData.name,
      email: userData.email,
      company: userData.company,
      password: userData.password,
      password_confirmation: userData.confirmPassword,
    });
    const { user: newUser, token } = res.data;
    localStorage.setItem('qr_token', token);
    localStorage.setItem('qr_user', JSON.stringify(newUser));
    setUser(newUser);
    return { success: true };
  };

  const logout = () => {
    api.post('/auth/logout').catch(() => {});
    localStorage.removeItem('qr_token');
    localStorage.removeItem('qr_user');
    setUser(null);
  };

  const updateUser = (nextUser) => {
    localStorage.setItem('qr_user', JSON.stringify(nextUser));
    setUser(nextUser);
  };

  return (
    <AuthContext.Provider
      value={{ user, loading, login, register, logout, setUser: updateUser }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
